<template>
  <div class="none-content">
    <img class="noImg" src="@/assets/none-icon.png" />
    <div class="none-content-label">暂无内容</div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.none-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 100px 0;
  &-label {
    font-size: 20px;
    color: #8a8a8a;
    margin-top: 18px;
  }
}
.noImg {
  width: 313px;
  height: 194px;
}
</style>
